import { createFileRoute } from '@tanstack/react-router';
import { OrganizationDetailPage } from '@/components/organizations/OrganizationDetailPage';

export const Route = createFileRoute('/_authenticated/organizations/$organizationId')({
  component: OrganizationDetailRoute,
});

function OrganizationDetailRoute() {
  const { organizationId } = Route.useParams();
  return <OrganizationDetailPage organizationId={organizationId} />;
}
